import { render, staticRenderFns } from "./copyStorageLocation.vue?vue&type=template&id=55b55b3e&scoped=true&"
import script from "./copyStorageLocation.vue?vue&type=script&lang=js&"
export * from "./copyStorageLocation.vue?vue&type=script&lang=js&"
import style0 from "./copyStorageLocation.vue?vue&type=style&index=0&id=55b55b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b55b3e",
  null
  
)

export default component.exports